import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { CustomAttributes } from '../../types/CustomAttributes'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { ExternalIconSize, Link } from '../Link'

export interface FooterLinkProps {
  customAttributes?: CustomAttributes
  isExternal?: boolean
  url?: string
}

export const FooterLink = ({
  children,
  customAttributes = {},
  isExternal,
  url,
}: PropsWithChildren<FooterLinkProps>) => {
  const linkStyle = classNames(
    'pb-1 border-b border-transparent transition-hover',
    'hover:text-primary',
    'focus:outline-none focus:text-primary focus:border-quinary'
  )

  if (isNullOrWhiteSpace(url)) {
    const hasCustomAttributes = Object.keys(customAttributes).length > 0

    return hasCustomAttributes ? (
      <a className={classNames(linkStyle, 'cursor-pointer')} {...customAttributes}>
        {children}
      </a>
    ) : (
      <>{children}</>
    )
  }

  return (
    <Link
      className={linkStyle}
      customAttributes={customAttributes}
      externalIconSize={ExternalIconSize.Sm}
      hideContentIfNoAccess
      isExternal={isExternal}
      url={url}
    >
      {children}
    </Link>
  )
}
